import * as React from 'react';
import cn from 'classnames';

type Props = {
  onClick?: any,
  title?: string,
  buttonStyle: string,
  buttonSize?: string,
  buttonColor?: string,
  buttonType?: | 'button' | 'submit' | 'reset'
  iconType?: string,
  customClass?: string,
  customStyle?: any,
  actionKey?: string,
  children?: any,
  disabled?: boolean,
  // button tag
  tagStyle?: boolean,
  tagActive?: boolean,
}

class Button extends React.Component <Props> {
  static defaultProps = {
    buttonType: 'button',
  };

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const { onClick, actionKey } = this.props;

    e.preventDefault();
    if (onClick) onClick(actionKey, e);
  }

  render() {
    const {
      title, buttonStyle, buttonSize, iconType, customClass, customStyle, buttonType, buttonColor,
      tagStyle, tagActive, disabled, children
    } = this.props;

    return (
      <button
        type={buttonType}
        className={
          cn('btn', {
            [buttonStyle]: !!buttonStyle,
            [buttonSize]: !!buttonSize,
            [buttonColor]: !!buttonColor,
            [customClass]: !!customClass,
            'btn--tag': tagStyle,
            'btn--tag--active': tagActive,
            'btn--disabled': disabled,
          })}
        style={customStyle}
        onClick={this.handleClick}
      >
        {
          iconType &&
          <span className="btn__i">
            <span className={cn('i', iconType)} />
          </span>
        }
        {title}
        {children}
      </button>
    )
  }
}

export default Button;
